import Verification from './Verification';
import TeamsEditor from './TeamsEditor';
import EntriesEditor from './EntriesEditor';
import { SubPagesLayout } from '../common';
import { Header } from '../../components';
import ormActions from '../../orm/actions';
import {
  createGendersSelector,
  createContestsSelector,
  createTeamsSelector,
  createEntriesSelector,
  createGroupsSelector,
} from '../../orm/selectors';
import { bickActions } from '../../common';

import { connect } from 'react-redux';
import React from 'react';

// TODO: Push into groups while editing/creating entries
const Entry = ({
  app,
  route,
  genders,
  contests,
  teams,
  entries,
  groups,
  actions,
}) => {
  const Teams = () => (
    <section>
      <Header as="h1">Team entries</Header>
      <TeamsEditor
        id="entry--teams-editor"
        teams={teams}
        meta={{}}
        actions={actions.team}
      />
    </section>
  );

  const Athletes = () => (
    <section>
      <Header as="h1">Athlete entries</Header>
      <EntriesEditor
        id="entry--entries-editor"
        entries={entries}
        meta={{ genders, contests, teams }}
        actions={actions.entry}
      />
    </section>
  );

  return (
    <SubPagesLayout app={app} route={route}>
      {[
        { slug: '', title: 'Teams', component: Teams },
        { slug: 'athletes', title: 'Athletes', component: Athletes },
        {
          slug: 'verification',
          title: 'Verification',
          render: () => (
            <Verification
              contests={contests}
              entries={entries}
              groups={groups}
              actions={actions}
            />
          ),
        },
      ]}
    </SubPagesLayout>
  );
};

Entry.slug = 'entry';
Entry.title = 'Entry';

const mapStateToProps = () => {
  const gendersSelector = createGendersSelector();
  const contestsSelector = createContestsSelector();
  const teamsSelector = createTeamsSelector();
  const entriesSelector = createEntriesSelector();
  const groupsSelector = createGroupsSelector();

  return ({ orm }) => ({
    genders: gendersSelector(orm),
    contests: contestsSelector(orm),
    teams: teamsSelector(orm),
    entries: entriesSelector(orm),
    groups: groupsSelector(orm),
  });
};

const mapDispatchToProps = dispatch => ({
  actions: bickActions(ormActions, ['team', 'entry', 'lot', 'group'], dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Entry);



// WEBPACK FOOTER //
// ./src/pages/Entry/Entry.js